import React, { Component } from 'react';
import Row from './Row'
import { iconEmpty, scrollToPos } from './../../../../services/helper'

class Rows extends Component {
    constructor(props) {
        super(props)
        this.refBodyPreviewImport = React.createRef();
    }

    componentDidUpdate() {
        scrollToPos(this.refBodyPreviewImport.current);
    }

    renderRows = () => {
        if (!this.props.listDataPreview.length) {
            return (
                <tr className="tr-empty">
                    <td colSpan={10}>{iconEmpty()}</td>
                </tr>
            )
        }
        return this.props.listDataPreview.map((e, i) => {
            return <Row
                    preview={e}
                    key={i}
                    keyRow={i}
                />
        })
    }

    render() {
        return (
            <tbody ref={this.refBodyPreviewImport}>{this.renderRows()}</tbody>
        );
    }
}

export default Rows;


// WEBPACK FOOTER //
// ./src/components/step-import-order/components/import-preview/Rows.js